import React, { useState, useEffect } from 'react';
import "react-data-table-component-extensions/dist/index.css";
import { useFormik, Formik, Form, Field } from 'formik';
import { AnnouncementSchema, EditAnnouncementSchema } from './MastersSchema';
import { useDispatch, useSelector } from 'react-redux';
import { AnnouncementListRes, AnnouncementListTodo } from '../../LMS_Redux/LMS_Slices/Masters/AnnouncementList';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PropagateLoader from "react-spinners/PropagateLoader";
import { departmentListTodo } from '../../LMS_Redux/LMS_Slices/Assets/DepartmentList';
import { addUpdateAnnouncementRes, addUpdateAnnouncementTodo } from '../../LMS_Redux/LMS_Slices/Masters/AddUpdateAnnouncement';
import Select from 'react-select'
import DataTables from '../LMS_DATA_TABLE/DataTable';
import AnnouncementListAction from '../LMS_DATA_TABLE/ActionButtons/AnnouncementList';
import { Spinner } from 'react-bootstrap';

export default function Announcement() {

    const dispatch = useDispatch()
    const departmentList = useSelector(state => state.depratmentList && state.depratmentList.data && state.depratmentList.data.data)
    const data = useSelector(state => state.announcementList && state.announcementList.data && state.announcementList.data.data)
    const [loading, setLoading] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [bool, setBool] = useState(false)
    const [editAnnouncement, setEditAnnouncement] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)
    const [edit, setEdit] = useState()
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedOptionsUpdate, setSelectedOptionsUpdate] = useState([]);

    let options = [];

    const dept_list = departmentList && departmentList?.filter(val => val?.vstatus == 'Active')?.map(value => options.push({
        value: value.did,
        label: value.vdepartment_name
    }));

    const handleSelectChange = (selected) => {
        if (selected && selected?.length && selected[selected?.length - 1].value === 'select-all') {
            // "Select All" option was clicked
            if (selectedOptions?.length === options?.length) {
                setSelectedOptions([]);
                setFieldValue('department', []);
            } else {
                setSelectedOptions(options);
                setFieldValue('department', options);
            }
        } else {
            setSelectedOptions(selected || []);
            setFieldValue('department', selected || []);
        }
    };

    const customOptions = [{ value: 'select-all', label: 'Select All' }, ...options];

    let optionsUpdate = [];

    const dept_list_update = departmentList && departmentList?.map(value => optionsUpdate.push({
        value: value.did,
        label: value.vdepartment_name
    }));

    const handleSelectChangeUpdate = (selected) => {
        if (selected && selected?.length && selected[selected?.length - 1].value === 'select-all') {
            // "Select All" option was clicked
            if (selectedOptions?.length === options?.length) {
                setSelectedOptionsUpdate([]);
                setEdit({ ...edit, department_data: [] });
            } else {
                setSelectedOptionsUpdate(options);
                setEdit({ ...edit, department_data: optionsUpdate });
            }
        } else {
            setSelectedOptionsUpdate(selected || []);
            setEdit({ ...edit, department_data: selected || [] });
        }
    };

    const combinedOptionsUpdate = [{ value: 'select-all', label: 'Select All' }, ...optionsUpdate];

    const initialValues = {
        title: '',
        description: '',
        department: selectedOptions || [],
        status: ''
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: AnnouncementSchema,

        onSubmit: (values, action) => {
            // console.log("new", values)
            setSpinner(true)
            dispatch(addUpdateAnnouncementTodo(values)).then(() => add_update_res(action))
        },
    })

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'SERIAL',
            valueGetter: 'node.rowIndex + 1',
            filter: 'false',
            suppressMenu: true,
            sortable: true,
            floatingFilter: false,
            // wrapText: true,
            // autoHeight: true,
            maxWidth: 100
        },
        {
            headerName: 'TITLE',
            field: 'announcement_title',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'DESCRIPTION',
            field: 'description',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'DEPARTMENT',
            field: 'department_data',
            valueFormatter: function (params) {
                return params.data.department_data.map(val => `${val.label}`).join(',')
            },
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'CREATED BY',
            field: 'created_by',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'CREATED ON',
            field: 'createdAt',
            // cellRenderer: params => new Date(params.value).toDateString(),
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: (dateFromFilter, cellValue) => {
                    // console.log("date", dateFromFilter)
                    // console.log("cell", cellValue)

                    if (cellValue == null) { return 0 };

                    const dateParts = cellValue.split('/');
                    // console.log(dateParts)
                    const day = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const year = Number(dateParts[2]);

                    const cellDate = new Date(year, month, day);

                    if (cellDate < dateFromFilter) {
                        return -1;
                    } else if (cellDate > dateFromFilter) {
                        return 1;
                    }
                    return 0
                },
                // minValidYear: 2000,
                // maxValidYear: 2021,
                inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
            },
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            suppressFiltersToolPanel: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'STATUS',
            field: 'status',
            cellRenderer: params => params.value == 'active' ? <span className='badge text-bg-success'>Active</span> : <span className='badge text-bg-danger'>Inactive</span>,
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            field: 'ACTIONS',
            cellRenderer: AnnouncementListAction,
            cellRendererParams: {
                editModal: setEditAnnouncement,
                modalLoading: setModalLoading,
                editForm: setEdit,
                departmentUpdate: setSelectedOptionsUpdate,
            },
            // wrapText: true,
            autoHeight: true,
        }
    ]);

    // const options = department

    const announcement_list_res = () => {
        if (AnnouncementListRes && AnnouncementListRes.success) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    const add_update_res = (action) => {
        if (addUpdateAnnouncementRes && addUpdateAnnouncementRes.success) {
            action.resetForm()
            toast.success(addUpdateAnnouncementRes.message, { position: "bottom-right" })
            setSpinner(false)
            setModalLoading(false)
            setEditAnnouncement(false)
            setBool(!bool)
            setSelectedOptions([])
            setSelectedOptionsUpdate([])
        } else {
            toast.error(addUpdateAnnouncementRes.message, { position: "bottom-right" })
            setModalLoading(false)
            setEditAnnouncement(false)
            setSpinner(false)
        }
    }

    useEffect(() => {
        setLoading(true)
        dispatch(departmentListTodo())
        dispatch(AnnouncementListTodo()).then(() => announcement_list_res())
    }, [bool])

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header'>
                    <span className='icon1'>Masters / </span>
                    <span className='icon2'>Announcement</span>
                </div>

                <div className='wrapper-admin mb-3'>
                    <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }} method='post'>
                        <div className="row">

                            <div className="col-12 col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label form_label">Title</label>
                                    <input type="text" className="form-control form_input" placeholder="Enter Title" id='title'
                                        name='title' value={values.title} onChange={handleChange} onBlur={handleBlur}
                                    />
                                    {errors.title && touched.title ? (<span className='text-danger form_label'>{errors.title}</span>) : null}
                                </div>
                            </div>

                            <div className="col-12 col-md-6">
                                <div className="mb-3">
                                    <label htmlFor="description" className="form-label form_label">Description</label>
                                    <textarea className="form-control form_input" placeholder="Enter Description" rows="1" id='description'
                                        name='description' value={values.description} onChange={handleChange} onBlur={handleBlur}
                                    />
                                    {errors.description && touched.description ? (<span className='text-danger form_label'>{errors.description}</span>) : null}
                                </div>
                            </div>

                            <div className="col-12 col-md-6">
                                <label htmlFor="" className="form-label form_label">Permission Granted To</label>
                                <Select
                                    closeMenuOnSelect={false}
                                    options={customOptions}
                                    value={values.department}
                                    onChange={handleSelectChange}
                                    onBlur={handleBlur}
                                    name='department'
                                    isMulti
                                    placeholder="Select Permission To"
                                    classNamePrefix="select"
                                    hideSelectedOptions={true}
                                />
                                {errors.department && touched.department ? (<span className='text-danger form_label'>{errors.department}</span>) : null}
                                {/* <label htmlFor="department" className="form-label form_label">Departments</label>
                                <select className="form-select form_input" aria-label="Default select example" id='department'
                                    name='department' value={values.department} onChange={handleChange} onBlur={handleBlur}
                                >
                                    <option value="">Select Department</option>
                                    {department && department.map((value, index) =>
                                        <option value={value.did} key={index}>{value.vdepartment_name}</option>
                                    )}
                                </select>
                                    {errors.department && touched.department ? (<span className='text-danger form_label'>{errors.department}</span>) : null} */}
                            </div>

                            <div className="col-12 col-md-6">
                                <label htmlFor="status" className="form-label form_label">Status</label>
                                <select className="form-select form_input" aria-label="Default select example" id='status'
                                    name='status' value={values.status} onChange={handleChange} onBlur={handleBlur}
                                >
                                    <option value="">Select Status</option>
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                </select>
                                {errors.status && touched.status ? (<span className='text-danger form_label'>{errors.status}</span>) : null}
                            </div>

                            <div className='text-end mt-3'>
                                <button className='btn btn_submit' type='submit' disabled={spinner ? true : false}>Submit
                                    {spinner ?
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className='ms-2'
                                        />
                                        : ''
                                    }</button>
                            </div>
                        </div>
                    </form>
                </div>

                {loading ?
                    <div className='wrapper-admin'>
                        <div className='text-center mb-3'>
                            <PropagateLoader
                                color="#2262C6"
                                size={20}
                            />
                        </div>
                    </div>
                    :
                    <DataTables
                        rowData={data}
                        columnDefs={columnDefs}
                    />
                }
            </div>

            <div className={editAnnouncement ? 'modal fade show d-block' : 'modal fade show d-none'} style={{ background: 'rgba(0,0,0,0.8)' }} >

                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Edit Announcement</h5>
                            <button type="button" className="btn-close" aria-label="Close" style={{ boxShadow: 'none' }} onClick={() => { setEditAnnouncement(false); setEdit() }}></button>
                        </div>

                        <Formik
                            initialValues={{
                                id: edit && edit.id || '',
                                title: edit && edit.announcement_title || '',
                                description: edit && edit.description || '',
                                department: selectedOptionsUpdate || [],
                                status: edit && edit.status || '',
                            }}
                            validationSchema={EditAnnouncementSchema}
                            enableReinitialize
                            onSubmit={(values, action) => {
                                // console.log("edit", values);
                                setModalLoading(true)
                                dispatch(addUpdateAnnouncementTodo(values)).then(() => add_update_res(action))
                            }}
                        >
                            {({ errors, touched, setFieldValue, values }) => (
                                <Form>
                                    {modalLoading ?
                                        <div className="modal-body">
                                            <div className='text-center mb-3'>
                                                <PropagateLoader
                                                    color="#2262C6"
                                                    size={20}
                                                />
                                            </div>
                                        </div>
                                        :
                                        <>
                                            <div className="modal-body">

                                                <div className="row">

                                                    <div className="col-12 col-lg-6">
                                                        <div className="mb-3">
                                                            <label htmlFor="edit_title" className="form-label form_label">Title</label>
                                                            <Field type="text" className="form-control form_input" placeholder="Enter Title" id='edit_title'
                                                                name='title'
                                                            />
                                                            {errors.title && touched.title ? (<span className='text-danger form_label'>{errors.title}</span>) : null}
                                                        </div>
                                                    </div>

                                                    <div className="col-12 col-lg-6">
                                                        <div className="mb-3">
                                                            <label htmlFor="edit_description" className="form-label form_label">Description</label>
                                                            <Field as='textarea' className="form-control form_input" placeholder="Enter Description" id='edit_description'
                                                                name='description' rows="1"
                                                            />
                                                            {errors.description && touched.description ? (<span className='text-danger form_label'>{errors.description}</span>) : null}
                                                        </div>
                                                    </div>

                                                    <div className="col-12 col-lg-6">
                                                        <div className="mb-3">
                                                            <label htmlFor="edit_department" className="form-label">Permission Granted To</label>
                                                            {/* <Field
                                                                as={Select}
                                                                closeMenuOnSelect={false}
                                                                options={options}
                                                                defaultValue={edit ? edit.department_data : ''}
                                                                onChange={(option) =>
                                                                    setFieldValue('department', option)
                                                                }
                                                                name='department'
                                                                isMulti
                                                                placeholder="Select Permission To"
                                                                classNamePrefix="select"
                                                            /> */}
                                                            <Select
                                                                closeMenuOnSelect={false}
                                                                options={combinedOptionsUpdate}
                                                                // defaultValue={edit ? edit.department_data : ''}
                                                                value={values?.department}
                                                                onChange={handleSelectChangeUpdate}
                                                                name='department'
                                                                isMulti
                                                                placeholder="Select Permission To"
                                                                hideSelectedOptions={true}
                                                            />

                                                            {errors.department && touched.department ? (<span className='text-danger form_label'>{errors.department}</span>) : null}

                                                            {/* <label htmlFor="edit_department" className="form-label">Department</label>
                                                            <Field as="select" className="form-select form_input" aria-label="Default select example" name='department' id='edit_department'>
                                                                <option value=''>Select Department</option>
                                                                {department && department.map((value, index) =>
                                                                    <option value={value.did} key={index}>{value.vdepartment_name}</option>
                                                                )}
                                                            </Field>
                                                            {errors.department && touched.department ? <span className='text-danger'>{errors.department}</span> : null} */}
                                                        </div>
                                                    </div>

                                                    <div className="col-12 col-lg-6">
                                                        <div className="mb-3">
                                                            <label htmlFor="edit_status" className="form-label">Status</label>
                                                            <Field as="select" className="form-select form_input" aria-label="Default select example" name='status' id='edit_status'>
                                                                <option value=''>Select Status</option>
                                                                <option value="active">Active</option>
                                                                <option value="inactive">Inactive</option>
                                                            </Field>
                                                            {errors.status && touched.status ? <span className='text-danger'>{errors.status}</span> : null}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="modal-footer">
                                                {/* <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button> */}
                                                <button type="submit" className="btn btn_submit">Update</button>
                                            </div>
                                        </>
                                    }
                                </Form>
                            )}
                        </Formik>
                    </div>
                </div>
            </div >
            <ToastContainer />
        </>
    );
}